import { render, staticRenderFns } from "./repost-btn.vue?vue&type=template&id=3fdfb854&scoped=true"
import script from "./repost-btn.vue?vue&type=script&lang=js"
export * from "./repost-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdfb854",
  null
  
)

export default component.exports